import './App.css';
import React, {Component} from 'react';
import Router from "./Router";
import Theme from "./Theme";
import MainContainer from "./containers/Main/MainContainer";
import {BrowserRouter} from 'react-router-dom';
import {w3cwebsocket as W3CWebSocket} from "websocket";
import {withSnackbar} from 'notistack';

class App extends Component {
    client = new W3CWebSocket('wss://clientportal-dev-api.vklabs-athena.com/ws/notifications/'); //gets room_name from the state and connects to the backend server 
    state = {
        notifications: []
    }

    // Notification Listener
    componentDidMount() {
        this.client.onopen = () => {
            console.log("WebSocket Client Connected");
        };

        this.client.onmessage = (message) => {
            const dataFromServer = JSON.parse(message.data);
            if (dataFromServer) {
                this.props.enqueueSnackbar(dataFromServer.message, {
                    preventDuplicate: true,
                    variant: dataFromServer.type,
                    anchorOrigin: {horizontal: 'right', vertical: 'bottom'}
                })
            }
        };
    }

    render() {
        return (
            <BrowserRouter>
                <Theme>
                    <Router/>
                </Theme>
            </BrowserRouter>
        );
    }
}

export default withSnackbar(App);

